/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProcurementType } from './ProcurementType';
import {
    ProcurementTypeFromJSON,
    ProcurementTypeFromJSONTyped,
    ProcurementTypeToJSON,
    ProcurementTypeToJSONTyped,
} from './ProcurementType';

/**
 * 
 * @export
 * @interface ProcurementTypeCount
 */
export interface ProcurementTypeCount {
    /**
     * 
     * @type {number}
     * @memberof ProcurementTypeCount
     */
    count?: number | null;
    /**
     * 
     * @type {ProcurementType}
     * @memberof ProcurementTypeCount
     */
    procurementType: ProcurementType;
}



/**
 * Check if a given object implements the ProcurementTypeCount interface.
 */
export function instanceOfProcurementTypeCount(value: object): value is ProcurementTypeCount {
    if (!('procurementType' in value) || value['procurementType'] === undefined) return false;
    return true;
}

export function ProcurementTypeCountFromJSON(json: any): ProcurementTypeCount {
    return ProcurementTypeCountFromJSONTyped(json, false);
}

export function ProcurementTypeCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProcurementTypeCount {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'] == null ? undefined : json['count'],
        'procurementType': ProcurementTypeFromJSON(json['procurementType']),
    };
}

export function ProcurementTypeCountToJSON(json: any): ProcurementTypeCount {
    return ProcurementTypeCountToJSONTyped(json, false);
}

export function ProcurementTypeCountToJSONTyped(value?: ProcurementTypeCount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'procurementType': ProcurementTypeToJSON(value['procurementType']),
    };
}

